import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../muiTheme';
import TextField from '@material-ui/core/TextField';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class EditFireCodeDialog extends Component
{

  constructor (props)
  {
    super(props);
 
    this.state =
    {   
        fireCode: '' 
    };
  }

  updateFireCode = (value) => {
    this.setState({
      fireCode: value
      });
  }

  fireCodeConfirmed = () => {
   window.api.updateFireCodeForAdmin(this.state.fireCode, this.props.fireOccurenceRecordId).then(resp => 
    {
      this.props.fireCodeEdited();
    });
  }


  componentWillReceiveProps(nextProps)
  {
    if (this.props.fireCode && this.props.fireCode !== nextProps.fireCode)
    this.setState({
      fireCode: nextProps.fireCode
    });
  }

render() {

    return (

      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Edit FireCode"
       open={this.props.open}>
              <DialogContent>
              Updating FireCode for {this.props.uniqueFireIdentifier}<br/><br/>
              <div style={{padding: "5px 5px 5px 5px"}}>
              New FireCode: <TextField value={this.state.fireCode} style={{ width: "240px" }} onChange={(e) => this.updateFireCode(e.target.value)}/>&nbsp;&nbsp;
              </div>
              </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onClose} color="primary">
          Cancel
        </Button>
          <Button onClick={this.fireCodeConfirmed} color="primary">
            Update FireCode
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default EditFireCodeDialog;
